import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./table-search.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./table-search.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { SharedConstants } from "../../constants/shared.constants";
import { PropertySearchService } from "../../../tabs/properties/shared/services/property-search.service";
import { PropertyTableColumnMappingService } from "../../services/table-column-mapping/property-table-column-mapping.service";
import { GraveSearchService } from "../../../tabs/graves/shared/services/grave-search.service";
import { ModuleConfigService } from "../../services/module-config/module-config.service";
import { BaySearchService } from "../../../tabs/bays/shared/services/bay-search.service";
import { BayTableColumnMappingService } from "../../services/table-column-mapping/bay-table-column-mapping.service";
import { PoiSearchService } from "../../../tabs/poi/shared/services/poi-search.service";
import { POITableColumnMappingService } from "../../services/table-column-mapping/poi-table-column-mapping.service";
import { StreetSearchService } from "../../../tabs/streets/shared/services/street-search.service";
import { StreetTableColumnMappingService } from "../../services/table-column-mapping/street-table-column-mapping.service";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
let TableSearchComponent = class TableSearchComponent {
    changeDetectorRef;
    propertySearchService;
    moduleConfigService;
    graveSearchService;
    baySearchService;
    poiSearchService;
    streetSearchService;
    propertyTableColumnMappingService;
    bayTableColumnMappingService;
    POIsTableColumnMappingService;
    streetTableColumnMappingService;
    searchColumnComponent;
    tableComponent;
    simpleSearchOccurred = new EventEmitter();
    advancedSearchOccurred = new EventEmitter();
    tableItemInteracted = new EventEmitter();
    pageHeading;
    columnToItemPropertyMap;
    showSearchButton;
    pageName;
    searchPlaceHolder;
    preSelected;
    placeHolder;
    parentComponent;
    searchByText;
    searchDebounce = 1000;
    dataSource;
    dataSourceSubscription;
    graveSearchTableColumnMapObservableSubscription;
    dataSource2Subscription;
    baySearchTableColumnMapObservableSubscription;
    dataSource3Subscription;
    poiSearchTableColumnMapObservableSubscription;
    dataSource4Subscription;
    streetSearchTableColumnMapObservableSubscription;
    dataSource5Subscription;
    propertySearchTableColumnMapMapObservableSubscription;
    constructor(changeDetectorRef, propertySearchService, moduleConfigService, graveSearchService, baySearchService, poiSearchService, streetSearchService, propertyTableColumnMappingService, bayTableColumnMappingService, POIsTableColumnMappingService, streetTableColumnMappingService) {
        this.changeDetectorRef = changeDetectorRef;
        this.propertySearchService = propertySearchService;
        this.moduleConfigService = moduleConfigService;
        this.graveSearchService = graveSearchService;
        this.baySearchService = baySearchService;
        this.poiSearchService = poiSearchService;
        this.streetSearchService = streetSearchService;
        this.propertyTableColumnMappingService = propertyTableColumnMappingService;
        this.bayTableColumnMappingService = bayTableColumnMappingService;
        this.POIsTableColumnMappingService = POIsTableColumnMappingService;
        this.streetTableColumnMappingService = streetTableColumnMappingService;
    }
    search(search) {
        this.simpleSearchOccurred.emit(search);
        this.changeDetectorRef.detectChanges();
    }
    ngOnInit() {
        this.searchByText = SharedConstants.SEARCH_BY_DEFAULT;
        this.searchPlaceHolder = this.searchPlaceHolder === ""
            ? `${SharedConstants.SEARCH_PREFIX} ${this.pageHeading.toLocaleLowerCase()}`
            : this.searchPlaceHolder;
        this.placeHolder = this.placeHolder === ""
            ? this.searchPlaceHolder
            : this.placeHolder;
    }
    ngAfterViewInit() {
        if (this.moduleConfigService.isCemeteryModule()) {
            this.setupGravesColumns();
        }
        else if (this.moduleConfigService.isInformalTradeModule()) {
            this.setupBaysColumns();
            this.setupPropertiesColumns();
        }
        else if (this.moduleConfigService.isStreetNamingModule()) {
            this.setupPOIColumns();
            this.setupStreetColumns();
            this.setupPropertiesColumns();
        }
        else {
            this.setupPropertiesColumns();
        }
        this.changeDetectorRef.detectChanges();
    }
    tableItemClicked($event) {
        this.tableItemInteracted.emit($event);
    }
    handleAdvancedSearch = (propertySearchCallback) => {
        // @ts-ignore
        this.advancedSearchOccurred.emit(propertySearchCallback);
    };
    setupGravesColumns() {
        this.dataSource = this.graveSearchService.gravesListAsObservable;
        this.dataSourceSubscription = this.dataSource.subscribe((ds) => {
            this.propertyTableColumnMappingService.setPropertyTableItems(ds);
        });
        this.graveSearchTableColumnMapObservableSubscription = this.graveSearchService.graveSearchTableColumnMapObservable.subscribe((tableColumnMap) => {
            this.propertyTableColumnMappingService.setPropertyTableColumnMap(tableColumnMap);
        });
    }
    setupBaysColumns() {
        this.dataSource = this.baySearchService.bayListAsObservable;
        this.dataSource2Subscription = this.dataSource.subscribe((ds) => {
            this.bayTableColumnMappingService.setBayTableItems(ds);
        });
        this.baySearchTableColumnMapObservableSubscription = this.baySearchService.baySearchTableColumnMapObservable.subscribe((tableColumnMap) => {
            this.bayTableColumnMappingService.setBayTableColumnMap(tableColumnMap);
        });
    }
    setupPOIColumns() {
        this.dataSource = this.poiSearchService.poiListAsObservable;
        this.dataSource3Subscription = this.dataSource.subscribe((ds) => {
            this.POIsTableColumnMappingService.setPOITableItems(ds);
        });
        this.poiSearchTableColumnMapObservableSubscription = this.poiSearchService.poiSearchTableColumnMapObservable.subscribe((tableColumnMap) => {
            this.POIsTableColumnMappingService.setPOITableColumnMap(tableColumnMap);
        });
    }
    setupStreetColumns() {
        this.dataSource = this.streetSearchService.streetListAsObservable;
        this.dataSource4Subscription = this.dataSource.subscribe((ds) => {
            this.streetTableColumnMappingService.setStreetTableItems(ds);
        });
        this.streetSearchTableColumnMapObservableSubscription = this.streetSearchService.streetSearchTableColumnMapObservable.subscribe((tableColumnMap) => {
            this.streetTableColumnMappingService.setStreetTableColumnMap(tableColumnMap);
        });
    }
    setupPropertiesColumns() {
        this.dataSource = this.propertySearchService.propertiesListAsObservable;
        this.dataSource5Subscription = this.dataSource.subscribe((ds) => {
            this.propertyTableColumnMappingService.setPropertyTableItems(ds);
        });
        this.propertySearchTableColumnMapMapObservableSubscription = this.propertySearchService.propertySearchTableColumnMapMapObservable.subscribe((tableColumnMap) => {
            this.propertyTableColumnMappingService.setPropertyTableColumnMap(tableColumnMap);
        });
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef },
        { type: PropertySearchService },
        { type: ModuleConfigService },
        { type: GraveSearchService },
        { type: BaySearchService },
        { type: PoiSearchService },
        { type: StreetSearchService },
        { type: PropertyTableColumnMappingService },
        { type: BayTableColumnMappingService },
        { type: POITableColumnMappingService },
        { type: StreetTableColumnMappingService }
    ];
    static propDecorators = {
        searchColumnComponent: [{ type: ViewChild, args: ["searchColumn",] }],
        tableComponent: [{ type: ViewChild, args: ["table", { static: true },] }],
        simpleSearchOccurred: [{ type: Output }],
        advancedSearchOccurred: [{ type: Output }],
        tableItemInteracted: [{ type: Output }],
        pageHeading: [{ type: Input }],
        columnToItemPropertyMap: [{ type: Input }],
        showSearchButton: [{ type: Input }],
        pageName: [{ type: Input }],
        searchPlaceHolder: [{ type: Input }],
        preSelected: [{ type: Input }],
        placeHolder: [{ type: Input }],
        parentComponent: [{ type: Input }]
    };
};
TableSearchComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-table-search[columnToItemPropertyMap]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], TableSearchComponent);
export { TableSearchComponent };
